import api from '@/api/auth';
// eslint-disable-next-line import/no-cycle
import store from '@/store';
import apiBoxes from '@/api/boxes';
import { HTTP_API, HTTP_CONFIG } from '@/http';
import * as types from './types';

export default {
  checkToken(context, params) {
    return apiBoxes
      .search(params)
      .then((response) => {
        if (response.status === 'success') {
          return Promise.resolve(response);
        }
        return Promise.reject(response);
      })
      .catch(err => Promise.reject(err));
  },
  resetToken({ commit }) {
    store.dispatch('application/pushAlert', {
      message: 'Votre session a expiré',
      type: 'warning',
    });
    commit('SET_SESSION', { auth: false, token: undefined });
    localStorage.clear();
  },
  check({ commit }) {
    let session;
    if (session === undefined) {
      session = JSON.parse(localStorage.getItem('epa-session'));
    }
    if (session === undefined || session === null) {
      commit('SET_SESSION', { auth: false, token: undefined });
    } else {
      commit('SET_SESSION', session);
    }
  },
  login(context, params) {
    return api
      .login(params)
      .then((response) => {
        if (!HTTP_API.hasSuccessStatus(response.data.status)) {
          return Promise.reject(response.data);
        }

        const session = {
          auth: true,
          token:
            HTTP_CONFIG.backOfficeVersion === HTTP_CONFIG.BACKOFFICE_V2
              ? response.headers['set-authorization']
              : HTTP_API.getContent(response.data).sessionId,
          sessionId: HTTP_API.getContent(response.data).sessionId,
        };
        context.commit('SET_SESSION', session);
        localStorage.clear();
        localStorage.setItem('epa-session', JSON.stringify(session));
        store.dispatch('application/resetAlert', []);
        store.dispatch('application/pushAlert', {
          message: 'Vous êtes connecté',
          type: 'success',
        });
        return Promise.resolve(response.data);
      })
      .catch((err) => {
        context.commit('SET_SESSION', { auth: false, token: undefined });
        store.dispatch('application/pushAlert', {
          message: 'Identifiant ou mot de passe incorrect',
          type: 'error',
        });
        return Promise.reject(err);
      });
  },
  clear({ commit }) {
    commit(types.SET_SESSION, { auth: false, guest: false, token: undefined });
  },
  logout({ dispatch }, params) {
    return api.logout(params).then((response) => {
      dispatch('resetToken');
      localStorage.clear();
      document.location.reload();
      return Promise.resolve(response);
    });
  },
};
